import React from 'react';
import {UserContext} from '@web/hooks/context';
import {Button, Card, Divider, List, Tag, Comment} from 'antd';
import {api} from '@web/lib/api';
import Icon from '@web/components/Icon';
import UserAvatar from '@web/components/UserAvatar';
import PropTypes from 'prop-types';

WorkflowAddJob.propTypes = {
  onAdd: PropTypes.func.isRequired,
};

function WorkflowAddJob (props) {
  const [userId] = React.useContext(UserContext);
  const [activeTabKey, setActiveTabKey] = React.useState("");
  const [sourcesList, setSourcesList] = React.useState([]);

  React.useEffect(() => {
    console.log("WorkflowAddJob:useEffect:", userId);
    api.LINE("/list-triggers", {userId})
    .then((sources) => {
      setSourcesList(Object.values(sources.data));
    });
  }, [userId]);

  const tabsContent = (type) => {
    return <div>
      <Divider className="hidden" />
      <List
        dataSource={sourcesList}
        renderItem={(source) => {
          return <List.Item>
            <Comment
              avatar={<UserAvatar icon={<Icon name={source.icon} />} />}
              actions={[<div className="space space-center-y gap-30">{Object.entries(source.events).map(([event, description]) =>
                <Button
                  key={event}
                  onClick={() => props.onAdd(source, event)}
                  type="dashed"
                  size="middle"
                  shape="round"
                  className="capitalize green-color muted"
                >{event}
                </Button>)}
                </div>
              ]}
              content={<span className="font-lg">{source?.description}</span>}
              author={<span className="font-lg">{source.source + " " + source.type}</span>}
            />
          </List.Item>
        }}
      />
    </div>
  }

  return <div style={{width: "600px", maxWidth: "100%", overflow: "auto"}}>
    <div className="space space-col relative" style={{maxWidth: 600}}>
      <br/>
      <Card
        className="card-simple card-rounded card-no-header card-no-separator card-h-600 card-body-scroll"
        bordered={false}
        tabList={[
          {key: "event", tab: "Events"},
          {key: "collection", tab: "Collections"},
          {key: "timer", tab: "Timer"},
        ]}
        tabProps={{
          centered: true,
        }}
        onTabChange={setActiveTabKey}
        activeTabKey={activeTabKey}
        tabBarExtraContent={{
          right: activeTabKey ? <Button
            // className={service ? "green-color" : ""}
            onClick={() => setActiveTabKey("")}
            shape="round"
          >Clear</Button> : null,
        }}
      >
        {tabsContent(activeTabKey)}
      </Card>
    </div>
  </div>
}

export default WorkflowAddJob;
